import { render, staticRenderFns } from "./ArchiveOff.vue?vue&type=template&id=77ceafd0"
import script from "./ArchiveOff.vue?vue&type=script&lang=js"
export * from "./ArchiveOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports